import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import App from "./App.vue";
import Auth from "./views/Auth";
import Rules from "./views/Rules";
import vuetify from "./plugins/vuetify";
import { store } from "./store/index.js";
import IoTRules from "./views/IoTRules.vue";

const routes = [
  {
    path: "/auth",
    component: Auth,
    name: "auth",
  },
  {
    path: "/rules",
    component: Rules,
  },
  {
    path: "/iot-rules",
    component: IoTRules,
  },
  {
    path: "/",
    redirect: "/rules",
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/rules",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    to.name !== "auth" &&
    store.state.authToken.length === 0 &&
    store.state.authIotFlagToken.length === 0
  ) {
    next({ name: "auth" });
  } else {
    next();
  }
});

const app = createApp(App);
app.use(router);
app.use(vuetify);
app.use(store);
app.mount("#app");
